import { useEffect } from 'react';
import { doTagSessionTimeoutModalPage } from 'components/sessionTimeOut/tagging';

export const useRecordPage = ({ showModal, userProfile, productsDescription, setPageName }) => {
    useEffect(() => {
        if (showModal) {
            setPageName(doTagSessionTimeoutModalPage(userProfile, productsDescription));
        }
    }, [showModal]);
};
